import * as React from 'react';
import { connect } from 'react-redux';
import { Formik, FormikProps, FormikValues } from 'formik';
import { Vertical, Card } from '@origin-digital/layout';
import { validation } from '../../validation';
import { SolarChecklist } from './SolarChecklist';
import { RequestConsultationFields } from './RequestConsultationFields';
import { RequestConsultationProps, RequestConsultationState } from './RequestConsultation.types';
import FormErrorSummary from '../../../../components/Form/Layout/FormErrorSummary';
import logger from '../../../../logging';
import analytics from '../../../../analytics';
import { isInitialValid } from '../../../../utils/formHelpers';
import { submitSolarForm } from '../../../../redux/thunks';
import { CreateLeadInput, SolarElectricRetailer } from '../../../../../__generated__/globalTypes';
import { getCustomer } from '../../../../redux/selectors';
import { StoreState } from '../../../../redux/store.types';

export class RequestConsultation extends React.Component<
  RequestConsultationProps,
  RequestConsultationState
> {
  constructor(props: RequestConsultationProps) {
    super(props);

    this.state = {
      reinitialize: true
    };
  }

  componentDidUpdate(nextProps: RequestConsultationProps): void {
    const { reinitialize } = this.state;
    const { customer } = this.props;
    if (customer.address !== nextProps.customer.address && reinitialize) {
      this.setState({
        reinitialize: false
      });
    }
  }

  public async submit(values: FormikValues): Promise<void> {
    const { submitSolarForm, showThankYouPage } = this.props;

    try {
      const { data } = await submitSolarForm(this.mapFormValuesToCreateLeadInput(values));

      if (data) {
        showThankYouPage();
        analytics.submitSuccessful({
          leadId: data.createLead.lead.leadId,
          solarProduct: values.productType,
          propertyType: values.propertyType,
          roofType: values.roofType,
          postcode: values.postcode
        });
      }
    } catch (error) {
      logger.error('GraphQL Error', error);
      return;
    }
  }

  public mapFormValuesToCreateLeadInput(values: FormikValues): CreateLeadInput {
    return {
      productType: values.productType,
      phone: values.phone,
      propertyType: values.propertyType,
      roofType: values.roofType,
      address: {
        unit: values.unit,
        streetNumber: values.streetNumber,
        streetName: values.streetName,
        streetType: values.streetType,
        suburb: values.suburb,
        state: values.state,
        postcode: values.postcode
      },
      comment: values.comment,
      firstName: values.firstName,
      lastName: values.lastName,
      email: values.email,
      allowMarketingCommunications: false,
      electricRetailer: SolarElectricRetailer.ORIGIN
    };
  }

  public render(): JSX.Element {
    const { customer } = this.props;
    const { reinitialize } = this.state;

    return (
      <Vertical horizontalAlign={'center'} layoutSize="compact">
        <Card>
          <SolarChecklist firstName={customer.firstName} />
        </Card>
        <FormErrorSummary marginBottom={3} />
        <Card>
          <Formik
            initialValues={customer}
            validationSchema={validation}
            enableReinitialize={reinitialize}
            isInitialValid={isInitialValid}
            onSubmit={this.submit.bind(this)}
            render={({ isValid }: FormikProps<FormikValues>) => (
              <RequestConsultationFields isValid={isValid} />
            )}
          />
        </Card>
      </Vertical>
    );
  }
}

const mapStateToProps = (state: StoreState) => ({
  customer: getCustomer(state)
});

export default connect(
  mapStateToProps,
  { submitSolarForm }
)(RequestConsultation);
